import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import * as moment from 'moment';
import { DatabaseService } from 'src/app/_services/database.service';
import swal from 'sweetalert';
import {Location} from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dealer-coupon-list',
  templateUrl: './dealer-coupon-list.component.html'
})
export class DealerCouponListComponent implements OnInit {
  
  data:any=[];
  dataNotFound=false
  reqSent=false
  autoFocus?: boolean = true;
  
  constructor(
    private _location: Location,
    public activatedroute:ActivatedRoute,
    public dialog: MatDialog,
    public db:DatabaseService
    ) { }
    ngOnInit() {
      this.todayDate =  moment(new Date ()).format('YYYY-MM-DD')
      this.getData();
     
      
    }
    todayDate :any
    pageNo:any=1;
    tempPageNo =1;
    totalPages:any
    start:any=0;
    limit:any=50;
    totalLength:any;
    filter:any={};
    getData(){
      this.dataNotFound = false;
      this.reqSent = false;
      this.filter.statusName = "Scanned";

      let reqData = {
        limit : this.limit,
        start : this.start,
        filter : this.filter,
        customer_encrypt_id: this.activatedroute.snapshot.params.id,
        registered: 0,
      }
      this.db.presentLoader();
      this.db.postReq(reqData,'coupon/list').subscribe(resp=>{
        this.reqSent = true;
        if(resp['status'] == 'success'){
          this.data = resp['result'].data;
          if(!this.data.length) this.dataNotFound = true;
          this.totalLength = resp['result'].totalCount;
          this.totalPages = Math.ceil(this.totalLength / this.limit);
          console.log('dearler data ',this.data);
          
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        
      })
    }
    pagination(action){
      if(action == 'pageNo'){
        if(this.pageNo > 0 && this.pageNo <=this.totalPages){
          this.start = this.limit*(this.pageNo-1)
        }else{
          this.pageNo = Math.ceil(this.totalLength / this.data.length);
        }
      }
      else if(action=='next'){
               if(this.totalLength == (this.start+this.data.length)) return;

        this.start = this.start+this.limit
        this.pageNo ++ ;
      }else{
        if(this.pageNo == 1) return
        this.start = this.start-this.limit
        this.pageNo -- ;
      }
      this.getData();
      this.tempPageNo = this.pageNo
    }
    refresh(){
      this.start = 0;
      this.limit = 50;
      this.filter = {};
      this.getData();
    }
    delete(data){
      swal({
        title: "Are you sure?",
        text: data.status == 1  ? "You want to make this Inactive!" : "You want to make this Active!",
        icon: "warning",
        buttons: ["Cancel", "Confirm"],
        dangerMode: true,
      })
      .then((willDelete) => {        
        if (willDelete) {
          this.db.presentLoader();
          data.status = data.status == 0 ? 1 : 0;
          data.role_id = data.id;
          this.db.postReq(data,'master/update_role').subscribe(resp=>{
            if(resp['status'] == 'success'){
              swal(data.status == 0 ? "Inactive!" : "Active", {
                icon: "success",
              });
            }else{
              if(resp['message']=='Invalid token'){
                this.db.sessionExpire();
                return;
              }
              this.db.presentAlert(resp['status'],resp['message'])
            }
          })
          
        } else {
          swal("Your data is safe!");
        }
      });
    }
    backClicked() {
      this._location.back();
    }
    // openDetail(row): void {
    //   console.log(row);
    
    //   const dialogRef = this.dialog.open(RoleDetailModelComponent, {
    //     width: '768px',
    //     autoFocus: false,
    //     data: row
    //   });
    
    //   dialogRef.afterClosed().subscribe(result => {
    //     console.log('The dialog was closed');
    //   });
    // }
    downloadExcel(){
      this.dataNotFound = false;
      this.reqSent = false;
      this.filter.statusName = "Scanned";
      let reqData = {
        filter : this.filter,
        customer_encrypt_id: this.activatedroute.snapshot.params.id,
        registered: 0,

      }
      this.db.presentLoader();
      this.db.postReq(reqData,'coupon/list/excel').subscribe(resp=>{
        this.reqSent = true;
        if(resp['status'] == 'success'){
          this.db.exportAsExcelFile(resp['result'].data,resp['result'].file_name ? resp['result'].file_name : 'exported_data');
        }else{
          if(resp['message']=='Invalid token'){
            this.db.sessionExpire();
            return;
          }
          this.db.presentAlert(resp['status'],resp['message'])
        }
      },err=>{
        
      })
      
    }
    reopen(){
      let arr=[];
      this.data.map(async r=>{
        if(r.checked == true){
          await arr.push(r.id)
        }
      })
      if(!arr.length){
        this.db.presentAlert('Error','Please select items first');   
        return; 
      }

      swal({
        title: "Are you sure?",
        text: "You want to reopen!",
        icon: "warning",
        buttons: ["Cancel", "Confirm"],
        dangerMode: true,
      })
      .then((willDelete) => {        
        if (willDelete) {
          this.db.presentLoader();
          let reqData = [];
          this.data.map(row=>{
            if(row.checked) reqData.push({coupon_id:row.encrypt_id,customer_id:row.cust_type_id == '3' ? row.cust_carpenter_encrypt_id : row.cust_fabricator_encrypt_id,point:row.point});
          })
          // data.point = data.cust_type_id == 4 ? data.architect_point;
          this.db.postReq(reqData,'coupon/reopen').subscribe(resp=>{
            if(resp['status'] == 'success'){
              this.getData();
              swal("Deleted", {
                icon: "success",
              });
            }else{
              if(resp['message']=='Invalid token'){
                this.db.sessionExpire();
                return;
              }
              this.db.presentAlert(resp['status'],resp['message'])
            }
          })
          
        } else {
          swal("Your data is safe!");
        }
      });
    }
    selectAll(event){
      this.data.map(r=>{
        if(event.checked == true && r.reopen_available){
          r.checked = true;
        }else{
          r.checked = false
        }
      })
    }
  }
  